import { T } from "@repo/transifex";
import { Button, Dialog } from "~/components";
import { useCountdown } from "~/hooks/use-countdown";
import { DEFAULT_COUNTDOWN_SECONDS } from "~/utils/constants";

export const DialogStandBy = ({
  onContinueSession,
  onCancelSession
}: {
  onContinueSession: () => void;
  onCancelSession: () => void;
}) => {
  const { timeLeftInSeconds } = useCountdown({
    countdownDurationInSeconds: DEFAULT_COUNTDOWN_SECONDS,
    onCountdownFinished: onCancelSession
  });

  return (
    <Dialog onOutsideClick={onContinueSession} size="md">
      <div className="flex flex-col items-center p-8">
        <p className="mb-8 text-center text-xl font-semibold">
          <T _str="Are you still there?" />
        </p>

        <Button
          className="mb-4 w-full"
          onClick={onCancelSession}
          variant="danger-light"
        >
          <T _str="Cancel order {seconds}" seconds={timeLeftInSeconds} />
        </Button>

        <Button className="w-full" onClick={onContinueSession}>
          <T _str="Continue ordering" />
        </Button>
      </div>
    </Dialog>
  );
};
